// extracted by mini-css-extract-plugin
module.exports = {"root":"JMHZvW","sliderWrapper":"QxZH_L","arrowContainer":"eGz2j5","visible":"yTxYuD","button":"YrOpKv","svgIcon":"rN6xZT","left":"kzGd1Z","right":"Xqp1OC"};